import { EVALIDATION_STATUS, EVALIDATOR_COMPLETED } from '../../../core/enums/customer.enum';
export const CUSTOMER_MOCK = {
  BASIC_INFO: {
    id: '62mock3c-1158-4045-94dc-394fc8mock35',
    external_id: 'email',
    status: 'active',
    display_name: 'Lorem Ipsum',
    email: 'email@email.com',
    phone_number: '912345678',
    website: '',
    others: {
      first_name: 'Lorem',
      middle_name: 'Ipsum',
      second_surname: 'Lorem',
      first_surname: 'Ipsum',
      occupation: 'Developer',
    },
  },
  VALIDATE_PENDING: {
    validation_status: EVALIDATION_STATUS.PENDING,
    validator_completed: null,
    has_card: null,
    can_request_loan: false,
    can_request_validator: true,
    has_payment_capacity: false,
  },
  VALIDATE_APPROVED: {
    validation_status: EVALIDATION_STATUS.APPROVED,
    validator_completed: null,
    has_card: false,
    can_request_loan: true,
    can_request_validator: false,
    has_payment_capacity: true,
  },
  VALIDATE_APPROVED_CARD: {
    validation_status: EVALIDATION_STATUS.APPROVED,
    has_card: true,
    can_request_loan: true,
  },
  VALIDATE_REJECTED: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: EVALIDATOR_COMPLETED.BURO,
    has_card: false,
    can_request_loan: true,
    can_request_validator: true,
    rejected_by_offer: false,
  },
  VALIDATE_REJECTED_RETRY: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: EVALIDATOR_COMPLETED.BURO,
    has_card: false,
    can_request_loan: false,
    can_request_validator: true,
    rejected_by_offer: false,
  },
  VALIDATE_REJECTED_BY_OFFER: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: EVALIDATOR_COMPLETED.BURO,
    has_card: false,
    can_request_loan: true,
    can_request_validator: false,
    rejected_by_offer: true,
  },
  VALIDATE_REJECTED_KEYNUA: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: EVALIDATOR_COMPLETED.KEY_NUA,
    has_card: false,
    can_request_loan: false,
    can_request_validator: true,
  },
  VALIDATE_REJECTED_KEYNUA_RETRY: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: EVALIDATOR_COMPLETED.KEY_NUA,
    has_card: false,
    can_request_loan: true,
    can_request_validator: false,
  },
  VALIDATE_CAN_REQUEST_LOAN: {
    validation_status: EVALIDATION_STATUS.APPROVED,
    has_card: false,
    can_request_loan: true,
  },
  VALIDATE_ERROR_BURO: {
    validation_status: EVALIDATION_STATUS.ERROR,
    validator_completed: EVALIDATOR_COMPLETED.BURO,
    has_card: null,
    can_request_loan: false,
    can_request_validator: true,
    has_payment_capacity: true,
    rejected_by_offer: null,
  },
  VALIDATE_ERROR_KEYNUA: {
    validation_status: EVALIDATION_STATUS.ERROR,
    validator_completed: EVALIDATOR_COMPLETED.KEY_NUA,
    has_card: null,
    can_request_loan: false,
    can_request_validator: true,
    has_payment_capacity: true,
    rejected_by_offer: null,
  },
  VALIDATE_ERROR_INSPEKTOR: {
    validation_status: EVALIDATION_STATUS.ERROR,
    validator_completed: EVALIDATOR_COMPLETED.INSPEKTOR,
    has_card: null,
    can_request_loan: false,
    can_request_validator: true,
    has_payment_capacity: true,
    rejected_by_offer: null,
  },
  VALIDATE_AGGREGATOR_CAPACITY_APPROVED: {
    validation_status: EVALIDATION_STATUS.APPROVED,
    validator_completed: null,
    has_card: false,
    can_request_loan: true,
    can_request_validator: false,
    has_payment_capacity: true,
    can_aggregator_capacity: true,
  },
  VALIDATE_AGGREGATOR_CAPACITY_REJECTED: {
    validation_status: EVALIDATION_STATUS.REJECTED,
    validator_completed: null,
    has_card: false,
    can_request_loan: false,
    can_request_validator: false,
    has_payment_capacity: true,
    can_aggregator_capacity: false,
  },
  VALIDATE_REJECTED_BY_PAYMENTS: {
    validation_status: EVALIDATION_STATUS.APPROVED,
    validator_completed: null,
    has_card: true,
    can_request_loan: false,
    can_request_validator: false,
    can_aggregator_capacity: true,
    has_payment_capacity: true,
    rejected_by_offer: false,
    rejected_by_payments: true,
  },
  // BLOCKING ERRORS:

  VALIDATION_DEFAULT_ERROR: {
    can_request_validator: false,
    can_request_loan: false,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    validation_status: EVALIDATION_STATUS.APPROVED,
  },

  VALIDATION_REJECTED_BY_PAYMENTS: {
    can_request_validator: false,
    can_request_loan: false,
    is_rejected_by_payments: true,
    is_blocked_by_signup_attempts: false,
    validation_status: EVALIDATION_STATUS.APPROVED,
  },

  VALIDATION_REJECTED_BY_ATTEMPTS: {
    can_request_validator: false,
    can_request_loan: false,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: true,
    validation_status: EVALIDATION_STATUS.APPROVED,
  },

  VALIDATION_STATUS_REJECTED: {
    can_request_validator: false,
    can_request_loan: false,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    validation_status: EVALIDATION_STATUS.REJECTED,
    is_rejected_by_offer: false,
  },

  VALIDATION_STATUS_REJECTED_OFFER: {
    can_request_validator: false,
    can_request_loan: false,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    validation_status: EVALIDATION_STATUS.REJECTED,
    is_rejected_by_offer: true,
  },

  VALIDATION_APPROVED_WITH_CAN_REQUEST_VALIDATOR: {
    can_request_validator: true,
    can_request_loan: true,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    is_rejected_by_offer: false,
    validation_status: EVALIDATION_STATUS.APPROVED,
    validator_completed: '',
    has_card: null,
  },

  VALIDATION_APPROVED_DEFAULT: {
    can_request_validator: false,
    can_request_loan: true,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    is_rejected_by_offer: false,
    validation_status: EVALIDATION_STATUS.APPROVED,
    validator_completed: '',
    has_card: null,
  },

  VALIDATION_PENDING_DEFAULT: {
    can_request_validator: true,
    can_request_loan: false,
    is_rejected_by_payments: false,
    is_blocked_by_signup_attempts: false,
    validation_status: EVALIDATION_STATUS.PENDING,
    validator_completed: null,
    is_rejected_by_offer: false,
    has_card: null,
  },

  VALIDATION_AGGREGATOR_APPROVED: {
    rejected_by_offer: false,
    can_request_loan: true,
    transaction_available: true,
    can_aggregator_capacity: true,
  },

  VALIDATION_AGGREGATOR_REJECTED: {
    rejected_by_offer: false,
    can_request_loan: false,
    transaction_available: false,
    can_aggregator_capacity: false,
  },

  VALIDATION_AGGREGATOR_REJECTED_CAPACITY: {
    rejected_by_offer: false,
    can_request_loan: false,
    transaction_available: false,
    can_aggregator_capacity: true,
  },

  VALIDATION_MAX_INSTALLMENT_APPROVED_CASE_1: {
    can_have_max_installment: true,
    have_other_installments: false,
    have_offers: false,
  },

  VALIDATION_MAX_INSTALLMENT_OFFERS_CASE_2: {
    can_have_max_installment: false,
    have_other_installments: true,
    have_offers: true,
  },

  VALIDATION_MAX_INSTALLMENT_SCORE_CASE_3: {
    can_have_max_installment: false,
    have_other_installments: false,
    have_offers: true,
  },

  VALIDATION_MAX_INSTALLMENT_REJECTED_CASE_4: {
    can_have_max_installment: false,
    have_other_installments: false,
    have_offers: false,
  },
};
